import React, { forwardRef, PropsWithChildren } from "react";
import { IButton } from "./typing";
import { MuiButton } from "./styles";

const Button = forwardRef<HTMLButtonElement, PropsWithChildren<IButton>>(
  ({ children, variant, isLoading, type = "button", ...rest }, ref) => {
    return (
      <MuiButton
        className="Button"
        data-testid="button-component"
        {...{
          type,
          variant,
          isLoading,
          ref,
        }}
        {...rest}
      >
        {isLoading ? <div>...</div> : children}
      </MuiButton>
    );
  },
);

Button.displayName = "button-component";

export default Button;
